import React from 'react';
import PropTypes from 'prop-types';
import './Typography.css';

export const Typography = ({ className, children }) => (
  <span className={className}>{children}</span>
);

Typography.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  className: PropTypes.string,
};

Typography.defaultProps = {
  children: [],
  className: 'regular-typography',
};
